import axios from "axios";

// Finansije restorana (transakcije, provizije, fakture, isplate...) zive na
// dostavljackom ("GPS") backendu, odvojenom od Topli Obrok backend-a
// (src/plugins/axios.js). Restoran ima poseban token za taj sistem, cuvamo ga
// pod GPS_TOKEN_KEY nezavisno od 'restoran-token'.
export const GPS_API_BASE =
  process.env.VUE_APP_GPS_API_BASE || "https://api.kurir.ordera.app/api";

export const GPS_TOKEN_KEY = "gps-token";

const gpsApi = axios.create({ baseURL: GPS_API_BASE });

gpsApi.interceptors.request.use((config) => {
  const token = window.localStorage.getItem(GPS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function hasGpsToken() {
  return !!window.localStorage.getItem(GPS_TOKEN_KEY);
}

export function setGpsToken(token) {
  window.localStorage.setItem(GPS_TOKEN_KEY, token);
}

export function clearGpsToken() {
  window.localStorage.removeItem(GPS_TOKEN_KEY);
}

export default gpsApi;
